module.exports = __webpack_public_path__ + "img/BT_language_UK.1dcacadd.svg";